enum EPromoRouteName {
  OVERVIEW = 'promo',
  FORM = 'promoForm',
}

export default EPromoRouteName;
